import React, { useEffect, useState } from "react";
import { Form, Input, Modal, Select } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { getStates } from "../../store/actions/state";
import { getCountries } from "../../store/actions/country";

const CityFormUpdate = ({ visible, onCreate, onCancel, record }) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const StateList = useSelector((state) => state.state.list);
  const countryList = useSelector((state) => state.country.list);

  const [stateToCountryMap, setStateToCountryMap] = useState({});

  useEffect(() => {
    if (visible) {
      dispatch(getCountries())
      dispatch(getStates());
    }
  }, [visible, dispatch]);

  useEffect(() => {
    const stateCountryMap = StateList.reduce((map, state) => {
      map[state.id] = state.coId; // Map state ID to country ID
      return map;
    }, {});
    setStateToCountryMap(stateCountryMap);
  }, [StateList]);

  useEffect(() => {
    if (record) {
      form.setFieldsValue(record);
      const countryId = stateToCountryMap[record.stId];
      form.setFieldsValue({
        coId: countryId || form.getFieldValue("coId"),
      });
    } else {
      form.resetFields();
    }
  }, [record,stateToCountryMap, form]);

   // Update coId when stId changes
   const handleStateChange = (value) => {
    const countryId = stateToCountryMap[value]; // Get countryId based on selected state
    form.setFieldsValue({
      coId: countryId, // Automatically set the country field when state changes
    });
  };

  return (
    <Modal
      visible={visible}
      title={"Update City"}
      okText="Submit"
      cancelText="Cancel"
      onCancel={onCancel}
      onOk={() => {
        form
          .validateFields()
          .then((values) => {
            onCreate(values);
            form.resetFields();
          })
          .catch((info) => {
            console.log("Validate Failed:", info);
          });
      }}
      width={800}
    >
      <Form
        form={form}
        layout="vertical"
        name="model_form"
        initialValues={record}
      >
        <Form.Item
          name="coId"
          label="Country"
          rules={[{ required: true, message: "Please select a country!" }]}
        >
          <Select placeholder="Select a country" showSearch  filterOption={(input, option) =>
            option.children.toLowerCase().includes(input.toLowerCase())
          }>
            {countryList.map((country) => (
              <Select.Option key={country.id} value={country.id}>
                {country.name}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item
          name="stId"
          label="State"
          rules={[{ required: true, message: "Please select a state!" }]}
        >
          <Select placeholder="Select a state" onChange={handleStateChange} showSearch  filterOption={(input, option) =>
            option.children.toLowerCase().includes(input.toLowerCase())
          }>
            {StateList.map((state) => (
              <Select.Option key={state.id} value={state.id}>
                {state.name}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item
          name="name"
          label="Name"
          rules={[{ required: true, message: "Please enter the city name!" }]}
        >
          <Input />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default CityFormUpdate;
